import React from 'react'
import { IconClose } from 'components/Zui/Icon'
import './index.css'

function Index({ headerText, onClose, children, actions, handleSubmit, setCreate }) {
    const buttonActions = actions.map(a =>
        a.ref === 'submit'
            ? {
                  ...a,
                  onClick: async () => {
                      await setCreate(false)
                      handleSubmit()
                  },
              }
            : a
    )

    return (
        <div className="share-popup-wrap">
            <div className="share-popup-header">
                <div className="title-wrap">
                    <span>{headerText}</span>
                </div>
                <div className="close-popup-wrap" onClick={onClose}>
                    <IconClose />
                </div>
            </div>
            {children}
            <div className="share-popup-footer">
                {buttonActions.map(action => {
                    return (
                        <div
                            className={
                                action.ref === 'submit'
                                    ? 'primary'
                                    : 'footer-button' && action.ref === 'cancel'
                                    ? 'cancel'
                                    : 'footer-button'
                            }
                            onClick={action.onClick}
                            key={action.title}
                        >
                            {action.title}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Index
